import { CompassCardComponentProps } from 'react-scale/corp/views/DataCompassV2/types';
import ColumnPicker from './ColumnPicker';
import ObjectTypePicker from './ObjectTypePicker';
import { ChatBulkAuditObjectType } from '@scale/genai-compass-shared/cards/chat_bulk_audit';
import { Typography } from '@scale/scaleui';

interface ObjectTypeAndColumnNamePickerProps {
  cardComponentProps: CompassCardComponentProps;
  selectedObjectType: ChatBulkAuditObjectType | undefined;
  setSelectedObjectType: (type: ChatBulkAuditObjectType) => void;
  selectedColumnWithObjectIds: string | undefined;
  setSelectedColumnWithObjectIds: (column: string) => void;
}

const ObjectTypeAndColumnNamePicker: React.FC<ObjectTypeAndColumnNamePickerProps> = ({
  cardComponentProps,
  selectedObjectType,
  setSelectedObjectType,
  selectedColumnWithObjectIds,
  setSelectedColumnWithObjectIds,
}) => {
  return (
    <div className="h-full flex flex-row space-x-1">
      <div className="flex-1 space-y-4 w-full">
        <Typography.Subtitle3>Select the type of objects to audit</Typography.Subtitle3>
        <ObjectTypePicker
          selectedObjectType={selectedObjectType}
          setSelectedObjectType={setSelectedObjectType}
        />
      </div>
      <div className="flex-1 space-y-4 w-full">
        <Typography.Subtitle3>Select the column with object IDs</Typography.Subtitle3>
        <ColumnPicker
          cardComponentProps={cardComponentProps}
          selectedColumnWithObjectIds={selectedColumnWithObjectIds}
          setSelectedColumnWithObjectIds={setSelectedColumnWithObjectIds}
        />
      </div>
    </div>
  );
};

export default ObjectTypeAndColumnNamePicker;
